import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { xor } from 'lodash';
import React, { FunctionComponent, useState } from 'react';
import { ForwardMediaIcon, ShoppingCartIcon } from '@lyse-as/formds-react/lib/icon/common';

import { DecoderSelect } from 'src/components/decoder-select';
import { addUpgradesToCartActionCreator } from 'src/state/cart/action-creators/add-upgrades-action-creator';
import { selectItemFromCart } from 'src/state/cart/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { I18nUtils } from 'src/utils/i18n-utils';
import { i18n } from 'src/i18n';
import { useSelectUpgradeDecoderOrThrow } from 'src/hooks/use-select-upgrade-decoder';

import { Upgrade } from './upgrade';
import { StyledDecoderContainer, StyledDescription, StyledDescriptionTitle } from './upgrade-several-page.styled';

export const UpgradeSeveralPage: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const { upgradableUnits } = useSelectUpgradeDecoderOrThrow();
  const { upgrade: decodersInCart } = useAppSelector(selectItemFromCart);
  const [selectedStbs, setSelectedStbs] = useState([...decodersInCart]);

  const toggleStb = (mac: string) => {
    setSelectedStbs(
      selectedStbs.includes(mac) ? selectedStbs.filter((selectedMac) => selectedMac !== mac) : [...selectedStbs, mac],
    );
  };

  const renderContent = () => (
    <>
      <Typography variant="paragraph2" component="p">
        {I18nUtils.message(i18n.page.upgradeSeveral.description, {
          stbCount: upgradableUnits.length,
        })}
      </Typography>
      <StyledDescriptionTitle variant="paragraph2" component="p">
        {i18n.page.upgradeSeveral.extendedDescription.title}
      </StyledDescriptionTitle>
      <StyledDescription variant="paragraph3" component="p">
        {i18n.page.upgradeSeveral.extendedDescription.text}
      </StyledDescription>
      <StyledDecoderContainer>
        {upgradableUnits.map((stb) => (
          <DecoderSelect onSelect={toggleStb} key={stb.mac} selected={selectedStbs.includes(stb.mac)} stb={stb} />
        ))}
      </StyledDecoderContainer>
    </>
  );

  const getButtonAddProps = () => {
    const disabled = selectedStbs.length === 0;

    return {
      children: (
        <>
          <ShoppingCartIcon /> {i18n.page.upgradeSeveral.addToCart}
        </>
      ),
      disabled,
    };
  };

  const getButtonUpdateProps = () => {
    const disabled = xor(decodersInCart, selectedStbs).length === 0;

    return {
      children: (
        <>
          <ForwardMediaIcon /> {i18n.page.upgradeSeveral.updateCart}
        </>
      ),
      disabled,
    };
  };

  return (
    <Upgrade
      content={renderContent()}
      buttonProps={{
        ...(decodersInCart.length === 0 ? getButtonAddProps() : getButtonUpdateProps()),
        onClick: () => dispatch(addUpgradesToCartActionCreator(selectedStbs)),
      }}
    />
  );
};
